import React, { useState, useContext } from 'react';
import { Layout } from 'antd';
import { StoreContext } from '../store/index';
import BottomNav from '../components/BottomNav';
import PitchBackground from '../components/PitchBackground';
import Requests from '../requests';
import ChatDrawer from '../chat/ChatDrawer';
import ConversationsDrawer from '../chat/ConversationsDrawer';
import './index.css';

function LayoutMenu({ children }) {
  const { Content } = Layout;
  const store = useContext(StoreContext);
  const {
    user: [user],
    allRequests: [allRequests],
    chat: [chatState, , closeChat],
    conversationsDrawer: [conversationsOpen, , closeConversations],
  } = store;

  const [requestsOpen, setRequestsOpen] = useState(false);

  const pendingCount = (allRequests ?? []).filter(r => r.to === user?.email).length;

  return (
    <Layout className="site-layout" style={{ position: 'relative' }}>
      <PitchBackground />
      <Content style={{ marginBottom: '56px', position: 'relative', zIndex: 1 }}>
        {children}
      </Content>
      <BottomNav
        pendingCount={pendingCount}
        onOpenRequests={() => setRequestsOpen(true)}
      />
      <Requests visible={requestsOpen} onClose={() => setRequestsOpen(false)} />
      <ConversationsDrawer
        visible={conversationsOpen}
        onClose={closeConversations}
      />
      <ChatDrawer
        conversationId={chatState.conversationId}
        recipientUid={chatState.recipientUid}
        recipientNickname={chatState.recipientNickname}
        recipientPhotoURL={chatState.recipientPhotoURL}
        recipientToken={chatState.recipientToken}
        visible={chatState.open}
        onClose={closeChat}
      />
    </Layout>
  );
}

export default LayoutMenu;
